import { Fragment, memo } from 'react';
import PropTypes from 'prop-types';

import { Radio, RadioGroup } from 'basic-components';

const ContractSort = ({ value = undefined, onChange, isRelativeOverridden = false }) => (
  <Fragment>
    <div
        className="ng-office-app__authed__content__body__item__expanded-settings__bottom__label"
        style={{ marginTop: 12 }}
    >
      Contract Type
    </div>
    <div className="ng-office-app__authed__content__body__item__expanded-settings__bottom__value ng-office-app__authed__content__body__item__expanded-settings__bottom__value--radio">
      <RadioGroup
          disabled={isRelativeOverridden}
          name="isRelative"
          onChange={onChange}
          selectedValue={value}
      >
        <Radio name="false">
          Absolute
        </Radio>
        <Radio name="true">
          Relative
        </Radio>
      </RadioGroup>
    </div>
  </Fragment>
)

ContractSort.propTypes = {
  isRelativeOverridden: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
}

export default memo(ContractSort)
